


















import { Component, Vue } from 'vue-property-decorator';

@Component
export default class Login extends Vue {
  private username: string = '';
  private password: string = '';

  private signIn(): Promise<any> {
    return this.$apiService.signIn(this.username, this.password, true)
    .then(() => {
      return this.$router.push('/');
    });
  }
}
